import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useUserContext } from "../contexts";

import spectraLogo from "../static/img/Spectra Plasmonics logo.webp";
import "../styles/Navbar.css";

//React-bootstrap
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

//Components
import AdminDropdown from "./navbar/AdminDropdown";
import DropdownMenu from "./navbar/DropdownMenu";
import MoreDropdown from "./navbar/MoreDropdown";
import OrderFormModal from "./ui/OrderFormModal";

const SpectraNavbar = () => {
  const { user } = useUserContext();
  const isAuthenticated = user?.isAuthenticated;
  const [modalVisible, setModalVisible] = useState(false);
  const navigate = useNavigate();

  return (
    <Navbar
      id='mainNav'
      fixed='top'
      className=' bg-light shadow '
      style={{ borderBottom: "0.3rem solid #e3803b" }}
      expand='lg'
    >
      <Container fluid className='d-flex flex-no-wrap align-items-center'>
        <Navbar.Brand as={Link} to='/'>
          <img
            alt='Spectra Plasmonics Logo'
            src={spectraLogo}
            style={{ maxWidth: "20rem", width: "50vw", minWidth: "14rem" }}
            className='d-inline-block align-top  '
          />
        </Navbar.Brand>
        {isAuthenticated && (
          <>
            <Navbar.Toggle aria-controls='navbarResponsive' />
            <Navbar.Collapse
              className='justify-content-end'
              id='navbarResponsive'
            >
              <Nav className='ms-auto align-items-center'>
                {user.role === "admin" && <AdminDropdown />}

                <Nav.Link as={Link} to='/'>
                  Testing Insights
                </Nav.Link>

                <Nav.Link as={Link} to='/recent'>
                  Recent Samples
                </Nav.Link>

                {user.subscriptionTier === "premium" && (
                  <Nav.Link as={Link} to='/map'>
                    Map
                  </Nav.Link>
                )}

                <DropdownMenu />

                <MoreDropdown
                  setModalVisible={setModalVisible}
                  customerType={user.customerType}
                />

                <Nav.Item
                  className={"btn btn-primary btn-md my-auto ms-2"}
                  onClick={() => navigate("/new")} //forces page reload
                >
                  New Sample
                </Nav.Item>
              </Nav>
            </Navbar.Collapse>
          </>
        )}
      </Container>
      <OrderFormModal
        showModal={modalVisible}
        handleClose={() => setModalVisible(false)}
        userId={user?.id}
      ></OrderFormModal>
    </Navbar>
  );
};

export default SpectraNavbar;
